import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useRequestPasswordResetMutation } from '../../redux/slices/authSlice';

// Components
import ForgotPasswordForm from './ForgotPasswordForm';
import Meta from '../shared/Meta';

import styles from '../../../stylesheets/public/layouts/Register.module.postcss';

function ForgotPassword() {
  const formRef = useRef(null);

  const [requestPasswordReset, { isSuccess, isError }] = useRequestPasswordResetMutation();
  const isComplete = isSuccess || isError;

  const onFormSubmit = async (data) => {
    await requestPasswordReset(data.email).unwrap();
    if (formRef.current) {
      formRef.current.reset();
    }
  };

  return (
    <div className={styles.Login + ' u-blockCenter u-limitWidth35 u-mb3 u-mt3'}>
      <Meta noindex />
      <h1 className='u-mb3 u-textCenter'>Forgot your password?</h1>
      <div className='Box Box--white'>
        <div>
          { isComplete &&
            <div className={styles.FormMessages}>
              <span className='icon icon-check' />
              <h4>
                Request sent! If you have an account with us, instructions have been sent to your email.
              </h4>
            </div>
          }

          <p>
            Enter your email address below and we&#39;ll send you password reset instructions.
          </p>

          <div className='u-mb1'>
            <ForgotPasswordForm
              ref={formRef}
              onSubmit={onFormSubmit}
            />
          </div>

          <hr/>

          <div>
            <Link to='/login'>Log in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
